import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const LayerContextMenu = ({ x, y, onClose, actions }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };

        // Use capture phase to ensure we catch it before other handlers
        document.addEventListener('mousedown', handleClickOutside, true);
        return () => document.removeEventListener('mousedown', handleClickOutside, true);
    }, [onClose]);

    // Adjust position if menu goes off-screen (lenient bounds for horizontal layout)
    const adjustedX = Math.min(Math.max(x, 150), window.innerWidth - 150);
    const adjustedY = Math.min(Math.max(y, 80), window.innerHeight - 30);

    return createPortal(
        <div
            ref={menuRef}
            className="fixed z-[9999] bg-[#1a1a1a]/95 backdrop-blur-md border border-gray-700/50 rounded-full shadow-2xl p-1.5 flex items-center gap-1 -translate-x-1/2 -translate-y-[calc(100%+12px)]"
            style={{ top: adjustedY, left: adjustedX }}
        >
            {actions.map((action, index) => {
                if (!action) return null;
                if (action.divider) {
                    return <div key={`divider-${index}`} className="w-px h-4 bg-gray-700 mx-1" />;
                }

                if (action.custom) {
                    return (
                        <div key={`custom-${index}`} className="flex items-center px-1" onClick={e => e.stopPropagation()}>
                            {action.custom}
                        </div>
                    );
                }

                return (
                    <button
                        key={action.label}
                        title={action.label}
                        onClick={(e) => {
                            e.stopPropagation();
                            action.onClick();
                            onClose();
                        }}
                        className={`flex items-center justify-center w-8 h-8 rounded-full transition-all duration-200 hover:bg-orange-500 group
              ${action.danger ? 'hover:bg-red-500 text-red-400' : 'text-gray-300 hover:text-white'}`}
                    >
                        {action.icon && (
                            <span className="flex-shrink-0 group-hover:scale-110 transition-transform">
                                {React.cloneElement(action.icon, { className: 'w-4 h-4' })}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>,
        document.body
    );
};

export default LayerContextMenu;
